var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.76058 9.33533H15.1123C16.0152 9.33533 16.5795 8.31957 16.0152 7.64241L11.8393 0.757875C11.3879 0.0807082 10.3721 0.0807082 9.92069 0.757875L5.74482 7.64241C5.29338 8.43244 5.85769 9.33533 6.76058 9.33533Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1432 21.7493C19.9481 21.7493 22.222 19.4755 22.222 16.6705C22.222 13.8656 19.9481 11.5918 17.1432 11.5918C14.3383 11.5918 12.0645 13.8656 12.0645 16.6705C12.0645 19.4755 14.3383 21.7493 17.1432 21.7493Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6786 12.1582H1.90693C1.34263 12.1582 0.77832 12.7225 0.77832 13.2868V20.0585C0.77832 20.6228 1.34263 21.1871 1.90693 21.1871H8.6786C9.24291 21.1871 9.80721 20.6228 9.80721 20.0585V13.2868C9.80721 12.7225 9.24291 12.1582 8.6786 12.1582Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategActive);
export default __webpack_public_path__ + "static/media/categActive.3e7ca989d93ba95881f4a52694afb7cb.svg";
export { ForwardRef as ReactComponent };